import { render, staticRenderFns } from "./FeedbackGrade.vue?vue&type=template&id=b2c831a8"
import script from "./FeedbackGrade.vue?vue&type=script&lang=js"
export * from "./FeedbackGrade.vue?vue&type=script&lang=js"
import style0 from "./FeedbackGrade.vue?vue&type=style&index=0&id=b2c831a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports